import thunk from 'redux-thunk';
import api from './api';
import appReadyMiddleware from './appReady';
import bookingSuccessMiddleware from './bookings';
import experimentsMiddleware from './experiments';

const getMiddleware = () => [
	thunk,
	api,
	appReadyMiddleware,
	experimentsMiddleware,
	bookingSuccessMiddleware,
];

export default getMiddleware;
